<template>
  <div>
    <!--banner -->
    <div class="case_bg">
      <banner></banner>
    </div>
    <div class="case_tabs">
      <ul class="list wow animated fadeInDown">
        <li v-for="(item, index) in caselist" :key="item.url">
          <!-- <router-link :to="item.url" active-class="active" exact @click="showClick(item.name)"> -->
          <div
            :class="{ active: activeIndex === index }"
            @click="showClick(item.name, index)"
          >
            <div class="box">
              <p>{{ item.name }}</p>
            </div>
          </div>
          <!-- </router-link> -->
        </li>
      </ul>
      <div class="router_box">
        <!-- <router-view ></router-view> -->
        <img src="../../assets/milan/1.png" alt="" id="img1" />
        <img src="../../assets/milan/2.png" alt="" id="img2" />
        <img src="../../assets/milan/3.png" alt="" id="img3" />
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import foot from "../../components/foot";
import banner from "../../components/banner";
export default {
  data() {
    return {
      shows: "进口电商SAAS小程序",
      activeIndex: 0, // 默认激活的索引
      // caselist:[
      //     {
      //         name:"网站开发",
      //         url:"/case/case1",
      //     },
      //     {
      //         name:"微信公众号",
      //         url:"/case/case2",
      //     },
      //     {
      //         name:"微信小程序",
      //         url:"/case/case3",
      //     },
      //     {
      //         name:"移动APP",
      //         url:"/case/case4",
      //     },
      //     {
      //         name:"优化项目",
      //         url:"/case/case5",
      //     },
      //     {
      //         name:"网络推广",
      //         url:"/case/case6",
      //     },
      // ]
      caselist: [
        {
          name: "进口电商SAAS小程序",
          url: "/case/case1",
        },
        {
          name: "电商CRM管理系统",
          url: "/case/case2",
        },
        {
          name: "进口电商平台定制",
          url: "/case/case3",
        },
      ],
    };
  },
  components: {
    foot,
    banner,
  },
  methods: {
    showClick(name, index) {
      this.shows = name;
      this.activeIndex = index;
      const imageId = `img${index + 1}`; // 根据索引生成对应的图片ID
      const imageElement = document.getElementById(imageId); // 获取图片元素
      if (imageElement) {
        imageElement.scrollIntoView({ behavior: "smooth" }); // 平滑滚动到图片位置
      }
    },
  },
  mounted() {
    new WOW().init();
  },
};
</script>
<style lang="less" scoped>
.icon {
  font-size: 36px;
}
a {
  color: #333;
}
.case_bg {
  //   height: 238px;
  height: 912px;
  margin: 0px auto;
  //   background-image: url(../../img/bg9.png);
  background-image: url(../../assets//milan/banner-3.png);
  background-repeat: no-repeat;
  background-size: cover;
  //   background-position: center;
}
.router_box {
  //   min-height:1200px;
  img {
    width: 100%;
    height: 660px;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
.height {
  max-height: 500px;
}
.case_tabs {
  .list {
    height: 200px;
    display: flex;
    box-shadow: 0px 15px 50px rgba(66, 159, 255, 0.1);
    padding: 20px;
    padding-bottom: 40px;
    li {
      // width:20%;
      width: 33%;
      background-repeat: no-repeat;
      background-position: center;
      background-position-y: 50px;
      border-radius: 30px;
      cursor: pointer;
      a {
        display: block;
        border-radius: 15px;
        &.active {
          box-shadow: 0px 15px 15px rgba(66, 159, 255, 0.2);
        }
        &:hover {
          box-shadow: 0px 15px 15px rgba(66, 159, 255, 0.2);
        }
      }
      div {
        display: block;
        border-radius: 15px;
        &.active {
          box-shadow: 0px 15px 15px rgba(66, 159, 255, 0.2);
        }
      }
      background-size: 92px 70px;
      &:nth-child(1) {
        background-image: url(../../img/ty1_1.png);
      }
      &:nth-child(2) {
        background-image: url(../../img/ty1_2.png);
      }
      &:nth-child(3) {
        background-image: url(../../img/ty1_3.png);
      }
      &:nth-child(4) {
        background-image: url(../../img/ty1_4.png);
      }
      &:nth-child(5) {
        background-image: url(../../img/ty1_5.png);
      }
      &:nth-child(6) {
        background-image: url(../../img/ty1_6.png);
      }
      .box {
        display: flex;
        width: 180px;
        height: 180px;
        margin: 15px auto 0px;
        border-radius: 20px;
        p {
          width: 100%;
          // font-size: 20px;
          font-size: 18px;
          margin-top: 125px;
          text-align: center;
          position: relative;
          &:after {
            content: "";
            position: absolute;
            top: 45px;
            left: 50%;
            margin-left: -10px;
            width: 20px;
            height: 2px;
            background-color: #0099ff;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/anli/case.vue